import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Hero from '../../components/pages/Home/Hero/Hero'
import WeLaunch from '../../components/pages/Home/WeLaunch/WeLaunch'
import OurCapabilities from '../../components/pages/Home/OurCapabilities/OurCapabilities'
import Industries from '../../components/pages/Home/Industries/Industries'
import WhyUs from '../../components/pages/Home/WhyUs/WhyUs'
import Portfolio from '../../components/pages/Home/Portfolio/Portfolio'
import Future from '../../components/pages/Home/Future/Future'
import LiftOff from '../../components/pages/Home/LiftOff/LiftOff'
import Footer from '../../components/shared/Footer/Footer'
import { HomePageProvider } from '../../context/HomePageContext'

const Home = () => {
  return (
    <HomePageProvider>
      <div>
        <Navbar />
        <Hero />
        <WeLaunch />
        <OurCapabilities />
        <Industries />
        <WhyUs />
        <Portfolio />
        <Future />
        <LiftOff />
        <Footer />
      </div>
    </HomePageProvider>
  )
}

export default Home